import * as THREE from 'three';
import Detector from './three/Detector';

const mapVersion = '4.1.0.2';

const config = {
  usesWebGL: Detector.webgl,
  isTouchDevice: ('ontouchstart' in document.documentElement),
  isMac: navigator.platform.toUpperCase().indexOf('MAC') >= 0,

  logTerminalVisible: false,
  statsVisible: false,

  rendererContainer: '#container',

  mapDataFile: CDN_URL + 'assets/js/country_data.json?v=' + mapVersion,
  saceDataFile: CDN_URL + 'assets/js/GetWorldData.json',

  contact_id: contact,
  other_id: other,

  saveMapData: false,
  mergedCountriesFilename: 'country_data.json',

  introRotateDuration: 4000, // 4000
  introWarpDelay: 4000, // 2000
  introWarpDuration: 2500, // 2500

  lineAnimateDuration: 800,
  lineAnimateSpeed: 10.0,
  lineDashOffsetLimit: 5.3,

  updateColorsDuration: 800,

  sourceCountryDefaultText: 'Source country',
  destinationCountryDefaultText: 'Destination country',

  viewSwitchDuration: 800,

  geoScale: 150, // 150
  mapOffsetX: -540, // -540
  mapOffsetY: 200, // 200
  globeRadius: 180,
  globeRotationX: -2.25,
  globeRotationY: 1.7,

  extrudeEnabled: false,
  extrudeDepth: 0.05,

  tesselationEnabled: true,
  tesselationMaxEdgeLength: 8,
  tesselationIterations: 100,//12,

  cameraFOV: 60.0,
  cameraDistance: 400.0,
  cameraDistanceMinReal: 200.0,
  cameraDistanceMin: 250.0,
  cameraDistanceMax: 400.0,
  cameraRotationSpeed: 0.7,
  cameraZoomSpeed: 25,
  cameraInitialPosition: new THREE.Vector3(-130.03879032534707, 120.51921441010587, 28.78117603305488),

  timeoutCamera: 2000,

  sphereEnabled: true,
  sphereVisible: false,
  
  colorCountryArrayDefault: [new THREE.Color(0xdddddd), new THREE.Color(0xc0c0c0), new THREE.Color(0xb0b0b0), new THREE.Color(0xa0a0a0), new THREE.Color(0x959595), new THREE.Color(0x858585), new THREE.Color(0x777777), new THREE.Color(0x666666), new THREE.Color(0x555555), new THREE.Color(0x444444), new THREE.Color(0x333333)],
  colorCountryArrayOpportunity: [new THREE.Color(0xdddddd), new THREE.Color(0xccd4cc), new THREE.Color(0xbbd2bc), new THREE.Color(0xa0cea1), new THREE.Color(0x83ca89), new THREE.Color(0x68c672), new THREE.Color(0x4cc157), new THREE.Color(0x30bd41), new THREE.Color(0x0fb92a), new THREE.Color(0x00900f), new THREE.Color(0x00740c)],
  colorCountryArrayRisk: [new THREE.Color(0xdddddd), new THREE.Color(0xd4cccc), new THREE.Color(0xd6b7c6), new THREE.Color(0xd49ab3), new THREE.Color(0xd4789d), new THREE.Color(0xd25c88), new THREE.Color(0xd13c74), new THREE.Color(0xd11d5e), new THREE.Color(0xce0248), new THREE.Color(0x900035), new THREE.Color(0x75002c)],
  colorCountryDefault: new THREE.Color(0x777777),
  colorCountryHover: new THREE.Color(0xdddddd),
  colorCountrySelected: new THREE.Color(0xdddddd),

  colorPinSelected: new THREE.Color(0xff1a54),

  pinColors: [0x00c5ff,0x007294],

/*   colorVisaNotRequired: new THREE.Color(0x333333), // 0xb7c801
  colorVisaOnArrival: new THREE.Color(0xff0000), // 0xfff000
  colorVisaETA: new THREE.Color(0xff0000), // 0xff9000
  colorVisaFreeEU: new THREE.Color(0xff0000), // 0x0055FF
  colorVisaRequired: new THREE.Color(0xff0000), // 0xFF0000
  colorVisaSpecial: new THREE.Color(0xff0000), // 0xff9000
  colorVisaAdmissionRefused: new THREE.Color(0xff0000), //
  colorVisaDataNotAvailable: new THREE.Color(0x333333), // 0xFF00FF

  colorZeroDestinations: new THREE.Color(0x333333), // 0x65bddd (blue), 0xffde00 (orange), 0x54ff00 (green), 0xffffff, 0xffffcc (yellow), 0x3c2062 (purple), 0x305c00 green
  colorMaxDestinations: new THREE.Color(0x333333), // 0x0035cc (blue), 0xcc0000 (red), 0x555555, 0xffe26c (yellow 2), 0xf2ff00 (yellow 3)
 */
  materialSphere: new THREE.MeshPhongMaterial({ color: 0xffffff, transparent: false, opacity: 1.0, wireframe: false, shading: THREE.SmoothShading, side: THREE.DoubleSide }),

  materialMap: new THREE.MeshPhongMaterial( { color: 0xFFFFFF, specular: 0xFFFFFF, shininess: 5, transparent: true, opacity: 0.9, side: THREE.DoubleSide, vertexColors: THREE.VertexColors } )

};


// only for non-BufferedGeometries:
config.materialCountryDefault = new THREE.MeshPhongMaterial({ color: config.colorCountryDefault, transparent: false, wireframe: false, shading: THREE.SmoothShading, side: THREE.DoubleSide });

// Chrome and Firefox seem to ignore linewidth when using WebGLRenderer:
config.materialCountryBorder = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1.5 } );
config.materialCountryBorderDisputed = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 0.0, transparent: true, opacity: 0.0 } );
config.materialLineDefault = new THREE.LineDashedMaterial( { color: config.colorCountryDefault, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
/* config.materialLineVisaNotRequired = new THREE.LineDashedMaterial( { color: config.colorVisaNotRequired, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaOnArrival = new THREE.LineDashedMaterial( { color: config.colorVisaOnArrival, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaETA = new THREE.LineDashedMaterial( { color: config.colorVisaETA, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaFreeEU = new THREE.LineDashedMaterial( { color: config.colorVisaFreeEU, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaRequired = new THREE.LineDashedMaterial( { color: config.colorVisaRequired, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaSpecial = new THREE.LineDashedMaterial( { color: config.colorVisaSpecial, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaAdmissionRefused = new THREE.LineDashedMaterial( { color: config.colorVisaAdmissionRefused, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
config.materialLineVisaDataNotAvailable = new THREE.LineDashedMaterial( { color: config.colorVisaDataNotAvailable, linewidth: 1.2, dashSize: 3, gapSize: 2, opacity: 0.5, transparent: true } ); // blending: THREE.AdditiveBlending
 */

export default config;
